import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { setupListeners } from "@reduxjs/toolkit/query";
import storage from "redux-persist/lib/storage";

// files
import { adminsReducer } from "./Slices";
import {
  adminsApi,
  projectsApi,
  uploaderApi,
  servicesApi,
  formsApi,
  employeesApi,
  aboutApi,
  categoriesApi,
  seoApi,
  blogsApi,
} from "./api";

// persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["adminsSlice"],
};

// combine Reducers
const rootReducer = combineReducers({
  // Slices
  adminsSlice: adminsReducer,
  // apis
  [adminsApi.reducerPath]: adminsApi.reducer,
  [projectsApi.reducerPath]: projectsApi.reducer,
  [uploaderApi.reducerPath]: uploaderApi.reducer,
  [servicesApi.reducerPath]: servicesApi.reducer,
  [formsApi.reducerPath]: formsApi.reducer,
  [employeesApi.reducerPath]: employeesApi.reducer,
  [aboutApi.reducerPath]: aboutApi.reducer,
  [categoriesApi.reducerPath]: categoriesApi.reducer,
  [seoApi.reducerPath]: seoApi.reducer,
  [blogsApi.reducerPath]: blogsApi.reducer,
});

// Persist reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// creating Store
export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(adminsApi.middleware)
      .concat(projectsApi.middleware)
      .concat(uploaderApi.middleware)
      .concat(servicesApi.middleware)
      .concat(formsApi.middleware)
      .concat(employeesApi.middleware)
      .concat(aboutApi.middleware)
      .concat(categoriesApi.middleware)
      .concat(seoApi.middleware)
      .concat(blogsApi.middleware),
});

setupListeners(store.dispatch);

// creating persist
export const persistor = persistStore(store);
